import { handleError } from '../gql/config/URQLProvider';
import { useGetMyIdQuery } from '../gql/graphql.generated';

export const useMyId = () => {
  const [{ data, error }] = useGetMyIdQuery();
  if (error) handleError(error);

  const myId = data?.myEmployee?.identityId;
  if (!myId) {
    throw new Error('Employee identityId is not available');
  }
  return myId as string;
};
